import { Component, OnInit } from '@angular/core';
import { ChartType, ChartOptions } from 'chart.js';
import { SingleDataSet, Label, Color, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { DashboardService } from 'src/app/services/dashboard.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';

@Component({
  selector: 'app-ar-charts',
  templateUrl: './ar-charts.component.html',
  styleUrls: ['./ar-charts.component.scss']
})
export class ArChartsComponent implements OnInit {


  piechartdata: number[] = [];
  piechartdataCA: number[] = [];
  piechartdataNUM: number[] = [];
  fromDate;
  toDate;
  summaryTransactions;
  dueTransactionsData;
  unPaidTransactionsData;
  pendingPaymentTypeTransactionsData;
  summaryReservations;

  filterSelection = 'Current Year - ' + moment().format('YYYY');
  
  public pieChartLabels: Label[] = [['Closed'], ['Open']];
  public pieChartData: SingleDataSet = this.piechartdata
  public pieChartDataCA: SingleDataSet = this.piechartdataCA;
  public pieChartDataNUM: SingleDataSet = this.piechartdataNUM;
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [pluginDataLabels];
  public pieChartColors: Array<any> = [{
    backgroundColor: ['#011e41','#4c86a0'],
    borderColor: ['#fff', '#fff', '#fff']
  }];
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'right',
      labels: {
        fontSize: 14,
      }
    },
    plugins: {

      datalabels: {
        color: '#ffffff',
        formatter: (value, ctx) => {
          const label = ctx.chart.data[ctx.dataIndex];
          return label;
        },
        font: {
          weight: 'bold',
          size: 16,
        }
      },
    }
  };

  constructor(public dasboardService : DashboardService, private spinner: NgxSpinnerService,) {

   }

  ngOnInit() {
    this.fromDate = moment().startOf('year').startOf('day').format('MM/DD/YYYY HH:mm');
    this.toDate = moment().endOf('year').endOf('day').format('MM/DD/YYYY HH:mm');
    this.transactinSummaryData();
    this.dueTransactions();
    this.unPaidTransactionsBySearch();
    this.pendingPaymentTypeTransactions();
    this.reservationsSummaryData();
  }

  currentYear() {
    this.filterSelection = 'Current Year - ' + moment().format('YYYY');
    this.fromDate = moment().startOf('year').startOf('day').format('MM/DD/YYYY HH:mm');
    this.toDate = moment().endOf('year').endOf('day').format('MM/DD/YYYY HH:mm');
    this.getData();
  }

  previousYear() {
    this.filterSelection = 'Previous Year - ' +  moment().subtract(1, 'year').format('YYYY');
    const py = moment().subtract(1, 'year');
    this.fromDate = moment(py).startOf('year').format('MM/DD/YYYY HH:mm');
    this.toDate = moment(py).endOf('year').endOf('day').format('MM/DD/YYYY HH:mm');
   // console.log(this.fromDate);
    //console.log(py.endOf('year').endOf('day').format('MM/DD/YYYY HH:mm'));
    this.getData();
  }

  getUTCDate(date) {
    return moment.utc(date).format('MMM DD, YYYY HH:mm');
  }

  getData() {
    this.dueTransactions();
    this.unPaidTransactionsBySearch();
    this.transactinSummaryData();
    this.pendingPaymentTypeTransactions();
    this.reservationsSummaryData();
  }

  async dueTransactions() {
    this.spinner.show();
    this.pieChartData.length = 0
    await this.dasboardService.getAllDueTransactions().subscribe(res => {
      if (res['status']) {
        this.dueTransactionsData = res['result'];
        //console.log(this.dueTransactionsData);
      }
    })
  }
  async unPaidTransactionsBySearch() {
    this.spinner.show();
    this.pieChartData.length = 0;
    await this.dasboardService.getUnPaidTransactionsBySearch(this.fromDate, this.toDate).subscribe(res => {
      this.spinner.hide();
      if (res['status']) {
        this.unPaidTransactionsData = res['result'];
       // console.log(this.unPaidTransactionsData);
      }
    })
  }
  async transactinSummaryData() {
    this.spinner.show();
    this.pieChartData.length = 0
    this.pieChartDataCA.length = 0
    await this.dasboardService.getTransactionsSummary(this.fromDate, this.toDate).subscribe(res => {
      this.spinner.hide();
      if (res['status']) {
        this.summaryTransactions = res['result'];

        for(let pie of  this.summaryTransactions){
          if(pie.CURRENCY_FLAG == 'CAD' && pie.PAYMENT_STATUS == 'P'){
            this.piechartdataCA.push(pie.TOTAL_AMOUNT); 
          }
          else if(pie.CURRENCY_FLAG == 'CAD' && pie.PAYMENT_STATUS == 'U') {
            this.piechartdataCA.push(pie.TOTAL_AMOUNT); 
          }
        }
        for(let pie of  this.summaryTransactions){
          if(pie.CURRENCY_FLAG == 'USD' && pie.PAYMENT_STATUS == 'P'){
            this.piechartdata.push(pie.TOTAL_AMOUNT); 
          }
          else if(pie.CURRENCY_FLAG == 'USD' && pie.PAYMENT_STATUS == 'U') {
            this.piechartdata.push(pie.TOTAL_AMOUNT); 
          }
        }

      }
    })

  }
  async pendingPaymentTypeTransactions() {
    this.spinner.show();
    this.pieChartData.length = 0
    await this.dasboardService.getPendingPaymentTypeTransactions(this.fromDate, this.toDate).subscribe(res => {
     this.spinner.hide();
      if (res['status']) {
        this.pendingPaymentTypeTransactionsData = res['result'];
        //console.log(this.pendingPaymentTypeTransactionsData);
      }
    })
  }


  async reservationsSummaryData() {
    this.spinner.show();
    this.pieChartData.length = 0
    this.pieChartDataCA.length = 0
    await this.dasboardService.getReservationsSummary(this.fromDate, this.toDate).subscribe(res => {
      this.spinner.hide();
      if (res['status']) {
        this.summaryReservations = res['result'];

        for(let pie of  this.summaryTransactions){
          if(pie.CURRENCY_FLAG == 'CAD' && pie.PAYMENT_STATUS == 'U'){
            this.piechartdataNUM.push(pie.TOTAL_AMOUNT); 
          }
          else if(pie.CURRENCY_FLAG == 'CAD' && pie.PAYMENT_STATUS == 'P') {
            this.piechartdataNUM.push(pie.TOTAL_AMOUNT); 
          }
        }
        for(let pie of  this.summaryTransactions){
          if(pie.CURRENCY_FLAG == 'USD' && pie.PAYMENT_STATUS == 'U'){
            this.piechartdataNUM.push(pie.TOTAL_AMOUNT); 
          }
          else if(pie.CURRENCY_FLAG == 'USD' && pie.PAYMENT_STATUS == 'P') {
            this.piechartdataNUM.push(pie.TOTAL_AMOUNT); 
          }
        }

      }
    })

  }

}
